export function isDeviceAndroid() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}